import React, { Fragment, useState, useMemo, useEffect } from 'react';
import _ from 'lodash';
import { Grid, Typography, FormControl, makeStyles } from '@material-ui/core';
import { TextField, Select, TextFieldDatePicker, HelperText, CheckBox } from '@components/atoms';
import { DragNDrop, DialogAlert, DialogConfirm } from '@components/molecules';
import moment from 'moment';

const CERT_STATUS_OPTIONS = [
    {
        label: 'Active',
        value: 'Active'
    },
    {
        label: 'Inactive',
        value: 'Inactive'
    },
];

const useStyles = makeStyles(theme => ({
    imageWrapper: {
        marginTop: theme.spacing(3),
    },
    typography: {
        color: theme.palette.primary.main,
    }
}));

const CertificateFields = (props) => {
    const {
        isSmUp, hash, formik, formik: { values }, state, setState, setOpenModal,
        addCertificate, eCardData,
        isChangingImage, certificates, eCardDataUpdatedRef
    } = props;
    const [ecardAlert, setEcardAlert] = useState(false);
    const [openUnVaccinatedConfirm, setopenUnVaccinatedConfirm] = useState(false);
    const classes = useStyles();

    const handleEcardModal = () => {
        setOpenModal(true);
        setEcardAlert(false);
    }

    const handleChangeImage = () => {
        formik.setFieldValue('certificateImage', '');
        // setIsChangingImage(true);
    }

    const isMissingCert = useMemo(() => (formik.values.certificateID && certificates ? certificates.find(cert => Number(cert.certificateID) === Number(formik.values.certificateID))?.disposition === 'MISSING' : true), [state.selectedCertificate]);

    const onDateChange = e => {
        let result = e.target.value;
        if (Number(result?.split('-')[0]) > 2099) result = '2099' + result.substring(4);
        else if (Number(result?.split('-')[0]) < 2000) result = '2000' + result.substring(4);
        const args = e;
        args.target.value = result;
        formik.handleChange(args);
        formik.handleBlur(args);
        formik.setFieldValue('expirationDate', moment(args.target.value, 'YYYY-MM-DD').add(1, 'year').format('YYYY-MM-DD'));
    }

    const onUnVaccinatedChange = (event) => {
        formik.handleChange(event);
        if (event.target.checked) setopenUnVaccinatedConfirm(prevState => !prevState);;
    };

    const onOkUnVaccinatedConfirmClickHandler = () => {
        formik.setFieldValue('isVaccineDeclined', true, false);
        formik.setFieldValue('issueDate', moment().format('YYYY-MM-DD'), false);
        formik.setFieldValue('expirationDate', moment().add(1, 'year').format('YYYY-MM-DD'), false);
        formik.setFieldValue('frontImage', '', false);
        formik.setFieldValue('backImage', '', false);
        formik.setFieldValue('activeFlag', 'Active', false);
        setopenUnVaccinatedConfirm(prevState => !prevState);
    }

    const onCancelUnVaccinateConfirmClickHandler = () => {
        setopenUnVaccinatedConfirm(prevState => !prevState);
        formik.setFieldValue('isVaccineDeclined', false);
    };

    useEffect(() => {
        formik.setFieldValue('isVaccineDeclined', false, false);
    }, []);

    const renderCertificateFields = () => {
        return (
            <Fragment>
                <Select
                    {...{
                        name: 'certificateID',
                        label: 'Credential Name',
                        className: 'center',
                        // onChange: formik.handleChange,
                        onChange: event => { formik.setFieldValue('certificateID', event.target.value); eCardDataUpdatedRef.current = false; },
                        onBlur: formik.handleBlur,
                        options: state.certificateTypesOptions || [],
                        formProps: { variant: "outlined", required: true, fullWidth: true, },
                        value: formik.values.certificateID,
                        error: formik.touched.certificateID && Boolean(formik.errors.certificateID),
                        helperText: formik.touched.certificateID && formik.errors.certificateID,
                        disabled: (!addCertificate && !isMissingCert)
                    }} />
                <Grid container justifyContent={"space-between"} >
                    <Grid item md={12}>
                        <TextFieldDatePicker
                            {...{
                                name: 'issueDate',
                                label: 'Vaccination Date',
                                className: 'center',
                                required: true,
                                onChange: formik.handleChange,
                                onBlur: onDateChange,
                                fullWidth: true,
                                variant: "outlined",
                                style: { width: '15rem' },
                                value: formik.values.issueDate,
                                error: formik.touched.issueDate && Boolean(formik.errors.issueDate),
                                helperText: formik.touched.issueDate && formik.errors.issueDate,
                                disabled: formik.values.isVaccineDeclined
                            }} />
                    </Grid>
                    <Grid item md={12}>
                        <TextFieldDatePicker
                            {...{
                                name: 'expirationDate',
                                label: 'Expiration Date',
                                className: 'center',
                                required: !formik.values.isVaccineDeclined,
                                onChange: formik.handleChange,
                                onBlur: onDateChange,
                                fullWidth: true,
                                variant: "outlined",
                                style: { width: '15rem' },
                                value: formik.values.expirationDate,
                                error: !formik.values.isVaccineDeclined && formik.touched.expirationDate && Boolean(formik.errors.expirationDate),
                                helperText: formik.touched.expirationDate && formik.errors.expirationDate,
                                disabled: true
                            }} />
                    </Grid>
                    <Grid item md={12}>
                        <CheckBox
                            {...{
                                name: 'isVaccineDeclined',
                                label: 'Declined',
                                onChange: onUnVaccinatedChange, //formik.handleChange,
                                formProps: { required: true, fullWidth: true, },
                                checked: formik.values.isVaccineDeclined,
                                error: formik.touched.isVaccineDeclined && Boolean(formik.errors.isVaccineDeclined),
                                helperText: formik.touched.isVaccineDeclined && formik.errors.isVaccineDeclined,
                                color: "primary"
                            }} />
                    </Grid>
                </Grid>

            </Fragment>
        );
    }

    const renderImageUploadFields = () => {
        return (
            <Fragment>
                <Grid item className={classes.imageWrapper}>
                    <FormControl className={classes.formControl} error={formik.touched.frontImage && Boolean(formik.errors.frontImage)}>
                        <Typography variant="h6" gutterBottom className={classes.typography}>
                            Front Image Upload
                        </Typography>
                        <DragNDrop {...{
                            name: 'frontImage',
                            required: !formik.values.isVaccineDeclined,
                            uploadedImage: formik.values.frontImage,
                            hasUploadedImage: !!formik.values.frontImage,
                            setUploadedImage: data => formik.setFieldValue('frontImage', data),
                            type: 'png, jpeg, jpg',
                        }} />
                        <HelperText {...{
                            error: !formik.values.isVaccineDeclined && formik.touched.frontImage && Boolean(formik.errors.frontImage),
                            helperText: formik.errors.frontImage,
                        }} />
                    </FormControl>
                </Grid>
            </Fragment>
        );
    };


    return (
        <Fragment>
            <Grid item xs={12} md={5}>
                {renderCertificateFields()}
            </Grid>
            <Grid item xs={12} md={6}>
                {renderImageUploadFields()}
            </Grid>
            <DialogConfirm {...{ dialogProps: { open: openUnVaccinatedConfirm, classes: { paper: classes.dialog } }, title: 'All fields will be cleared. Do you wish to Continue?', onOkClickHandler: onOkUnVaccinatedConfirmClickHandler, onCancelClickHandler: onCancelUnVaccinateConfirmClickHandler }} />

        </Fragment>
    );
};

export default CertificateFields;